import { push } from 'connected-react-router'
import { addDays, isAfter, isSameDay } from 'date-fns'
import React, { FC, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { OrderByBreadTemplate } from 'components/Templates'
import { TopHeadline } from 'components/Typography'
import { useHeadline } from 'hooks/order'
import { dateToString, parseToDate } from 'lib/helper'

const OrderByBread: FC = () => {
  const headingRef = useRef<HTMLHeadingElement>(null)
  const dispatch = useDispatch()
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const date = /\/order\/.+\/product/.test(pathname) ? pathname.split('/order/')[1].split('/product')[0] : undefined
  const currentDate = date ? parseToDate(date) : new Date()
  const isToday = isSameDay(currentDate, new Date())
  const isFuture = isAfter(currentDate, new Date())
  const headline = useHeadline(currentDate)
  const handlePrevDate = () => {
    const prevDate = addDays(currentDate, -1)
    dispatch(push(`/order/${dateToString(prevDate)}/product`))
  }
  const handleNextDate = () => {
    const nextDate = addDays(currentDate, 1)
    dispatch(push(`/order/${dateToString(nextDate)}/product`))
  }

  return (
    <Layout
      customHeadline={
        <TopHeadline
          ref={headingRef}
          headline={headline}
          iconPath="/icon/white/schedule.svg"
          prevIcon={<img src="/icon/arrow_prev.svg" alt="前の日付へ" onClick={handlePrevDate} />}
          nextIcon={<img src="/icon/arrow_next.svg" alt="次の日付へ" onClick={handleNextDate} />}
          size="small"
        />
      }
      headingRef={headingRef}
      title={'この日お渡しする注文-商品別'}
    >
      <OrderByBreadTemplate isPast={!isFuture && !isToday} />
    </Layout>
  )
}

export default OrderByBread
